import { useRouterState } from '@tanstack/react-router';

export function LoadingOverlay() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-overlay/30 backdrop-blur-sm z-50">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-on-color border-t-transparent"></div>
    </div>
  );
}

function GlobalLoader() {
  const { isLoading } = useRouterState();

  if (!isLoading) return null;

  return <LoadingOverlay />;
}

export default GlobalLoader;
